import { gql, TypedDocumentNode } from '@apollo/client';

import {
  Export,
  ExportCreateInput,
  ExportEvaluateInput,
  ExportsConnection,
  ExportsConnectionInput,
  ExportUpdateInput,
  ProjectionOptionsConnection,
  ProjectionOptionsConnectionInput,
} from '@atom/types/export';

const BASE_WORK_FILTERS = gql`
  fragment BaseWorkFilters on ExportFilter {
    dueDateStart
    dueDateEnd
    withoutDueDate
    createdDateStart
    createdDateEnd
    createdByIds
    startDateStart
    startDateEnd
    completionDateStart
    completionDateEnd
    durationStart
    durationEnd
    priorityIds
    statusIds
    workTemplateIds
    userIds
    groupIds
    categoryIds
    assetId
    completedByIds
    hasWorkTemplate
    name
    assetSchemaId
    hasForms
    tasks {
      dueDateStart
      dueDateEnd
      startDateStart
      startDateEnd
      completionDateStart
      completionDateEnd
      durationStart
      durationEnd
      each {
        id
        fields {
          id
          valueStart
          valueEnd
          value
          values
        }
      }
    }
    fields {
      id
      valueStart
      valueEnd
      value
      values
    }
  }
`;

const BASE_EXPORT = gql`
  fragment BaseExport on Export {
    id
    name
    type
    filter {
      ...BaseWorkFilters
    }
    projections {
      id
      name
      selectedFields
    }
    workTemplate {
      id
      name
    }
    createdDate
    createdBy {
      id
      firstName
      lastName
      email
    }
    updatedDate
    updatedBy {
      id
      firstName
      lastName
      email
    }
  }
  ${BASE_WORK_FILTERS}
`;

export const GET_EXPORT: TypedDocumentNode<{ export: Export }, { id: string }> =
  gql`
    query export($id: ID!) {
      export(id: $id) {
        ...BaseExport
      }
    }
    ${BASE_EXPORT}
  `;

export const GET_EXPORTS: TypedDocumentNode<
  { exports: ExportsConnection },
  { input: ExportsConnectionInput }
> = gql`
  query exports($input: ExportsConnectionInput!) {
    exports(input: $input) {
      exports {
        ...BaseExport
      }
      totalCount
    }
  }
  ${BASE_EXPORT}
`;

export const GET_PROJECTION_OPTIONS: TypedDocumentNode<
  { projectionOptions: ProjectionOptionsConnection },
  { input: ProjectionOptionsConnectionInput }
> = gql`
  query projectionOptions($input: ProjectionOptionsConnectionInput!) {
    projectionOptions(input: $input) {
      projectionOptions {
        id
        name
        availableFields
        customFields
        type
      }
    }
  }
`;

export const EXPORT_CREATE: TypedDocumentNode<
  { exportCreate: Export },
  { input: ExportCreateInput }
> = gql`
  mutation exportCreate($input: ExportCreateInput!) {
    exportCreate(input: $input) {
      ...BaseExport
    }
  }
  ${BASE_EXPORT}
`;

export const EXPORT_UPDATE: TypedDocumentNode<
  { exportUpdate: Export },
  { input: ExportUpdateInput }
> = gql`
  mutation exportUpdate($input: ExportUpdateInput!) {
    exportUpdate(input: $input) {
      ...BaseExport
    }
  }
  ${BASE_EXPORT}
`;

export const EXPORT_EVALUATE: TypedDocumentNode<
  { exportEvaluate: Export },
  { input: ExportEvaluateInput }
> = gql`
  mutation exportEvaluate($input: ExportEvaluateInput!) {
    exportEvaluate(input: $input) {
      ...BaseExport
    }
  }
  ${BASE_EXPORT}
`;

export const EXPORT_DELETE: TypedDocumentNode<
  { exportDelete: boolean },
  { id: string }
> = gql`
  mutation exportDelete($id: ID!) {
    exportDelete(id: $id)
  }
`;
